// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".SticksForm-module-stepCountLabel-WKaFq{font-weight:450}.SticksForm-module-stepSection-2rjNU{margin-bottom:25px}", ""]);
// Exports
exports.locals = {
	"stepCountLabel": "SticksForm-module-stepCountLabel-WKaFq",
	"stepSection": "SticksForm-module-stepSection-2rjNU"
};
module.exports = exports;
